import stickybits from 'stickybits'

import {
    Controller
} from "stimulus"

export default class extends Controller {
    stickybits

    /**
     * The controller has loaded.
     */
    connect() {
        this.stickybits = stickybits(this.element, { useStickyClasses: true })
        window.dispatchEvent(new CustomEvent('scroll'))
    }

    /**
     * The controller has disconnected.
     */
    disconnect()
    {
        this.stickybits.cleanup()
    }
}
